export default function DaytonaFinalCTA() {
  return (
    <section className="bg-[#1A365D] py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">Ready to Get Your Passport?</h2>
        <p className="text-white/70 text-lg mb-8 max-w-2xl mx-auto">Start your expedited passport application today. Fast Passport Center serves Daytona Beach and Volusia County travelers with fast, reliable courier service.</p>
        <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-10 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap">Get Started Now <i className="ri-arrow-right-line"></i></a>
      </div>
    </section>
  );
}